import { useEffect, useState } from 'react';
import { useTitle } from '../HooksPublic';
import { CDN_URL } from '../ConfigPublic';
import classNames from 'classnames';
import Product from '../components/Product';
import { HeroVideo } from '../components';

import '../style/customized_social.scss';

interface SocialProduct {
	title: string;
	img: string;
	desc?: string;
}

interface SocialCategory {
	name: string;
	products: SocialProduct[];
	flavors?: SocialProduct[];
	sizes_title?: string;
	sizes_subtitle?: string;
	flavors_title?: string;
	flavors_subtitle?: string;
}

interface CustomizedSocialData {
	categories: SocialCategory[];
}

const DEFAULT_DATA: CustomizedSocialData = {
	categories: [
		{
			name: 'Tabletas',
			sizes_title: 'Tabletas Personalizadas',
			sizes_subtitle: 'Tamaños a elegir',
			flavors_title: 'Sabores a elegir',
			flavors_subtitle: 'Puedes combinar, dependiendo de tu pedido son los sabores que puedes escoger.',
			products: [
				{ title: "Tableta mini", desc: "Medidas: 3 x 6.5 cm | 12 gr.", img: `${CDN_URL}/static/social/TABLETA_MINI.webp` },
				{ title: "Tableta Chica", desc: "Medidas: 6.5 x 9.5 cm | 40 gr.", img: `${CDN_URL}/static/social/TABLETA_CHICA.webp` },
				{ title: "Tableta Grande", desc: "Medidas: 7 x 15 cm | 80 gr.", img: `${CDN_URL}/static/social/TABLETA_GRANDE.webp` },
			],
			flavors: [
				{ title: "Chocolate de origen - SANTANDER 85%", img: `${CDN_URL}/static/social/TABLETAS/SANTANDER.webp` },
				{ title: "Chocolate de Origen - ARAUCA 70%", img: `${CDN_URL}/static/social/TABLETAS/ARAUCA.webp` },
				{ title: "Chocolate 58% - Libre de azúcar", img: `${CDN_URL}/static/social/TABLETAS/CHOCO_ORIGEN.webp` },
				{ title: "Chocolate de Origen - ARAUCA 70% + Frutos secos", img: `${CDN_URL}/static/social/TABLETAS/FRUTOS SECOS-1.webp` },
				{ title: "Chocolate 58% + GOJI BERRY", img: `${CDN_URL}/static/social/TABLETAS/GOJI.webp` },
				{ title: "Chocolate + praliné de almendras", img: `${CDN_URL}/static/social/TABLETAS/PRALINÉ.webp` },
				{ title: "Chocolate de origen + Frutos Rojos Tumaco", img: `${CDN_URL}/static/social/TABLETAS/FRUTOS SECOS.webp` },
				{ title: "Chocolate Blanco + Almendrina + Matcha", img: `${CDN_URL}/static/social/TABLETAS/MATCHA.webp` },
			],
		},
		{
			name: 'Chocolate original',
			sizes_title: 'Chocolates Originales',
			sizes_subtitle: 'Tamaños a elegir',
			flavors_title: 'Sabores a elegir',
			flavors_subtitle: 'Puedes combinar, dependiendo de tu pedido son los sabores que puedes escoger.',
			products: [
				{ title: "Caja chica", desc: "Medidas: 3 x 6.5 cm | 12gr.", img: `${CDN_URL}/static/social/CAJA_CHICA.webp` },
				{ title: "Caja Mediana", desc: "Medidas: 6.5 x 9.5 cm | 40gr.", img: `${CDN_URL}/static/social/CAJA_MEDIANA.webp` },
				{ title: "Caja Grande", desc: "Medidas: 7 x 15 cm | 80gr.", img: `${CDN_URL}/static/social/CAJA_GRANDE.webp` },
			],
			flavors: [
				{ title: "Chocolate de origen - SANTANDER 85%", img: `${CDN_URL}/static/social/TABLETAS/0.webp` },
				{ title: "Chocolate de origen - ARAUCA 70%", img: `${CDN_URL}/static/social/TABLETAS/1.webp` },
				{ title: "Chocolate de origen - ARAUCA 70% + Frutos secos", img: `${CDN_URL}/static/social/TABLETAS/2.webp` },
				{ title: "Chocolate 58% - Libre de azúcar", img: `${CDN_URL}/static/social/TABLETAS/3.webp` },
				{ title: "Chocolate 58% - Toffee", img: `${CDN_URL}/static/social/TABLETAS/4.webp` },
				{ title: "Chocolate de leche - Praliné de avellanas", img: `${CDN_URL}/static/social/TABLETAS/5.webp` },
				{ title: "Chocolate de leche - Cereal", img: `${CDN_URL}/static/social/TABLETAS/6.webp` },
				{ title: "Chocolate de leche - arroz inflado", img: `${CDN_URL}/static/social/TABLETAS/7.webp` },
			],
		},
		{
			name: 'Confitería',
			products: [
				{ title: "Tortubox 2 piezas", desc: "Medidas: 3 x 6.5 cm | 12gr.", img: `${CDN_URL}/static/social/TBOX_CHICA.webp` },
				{ title: "Tortubox 4 piezas", desc: "Medidas: 6.5 x 9.5 cm | 40gr.", img: `${CDN_URL}/static/social/TBOX_MEDIANA.webp` },
				{ title: "Tortubox 9 piezas", desc: "Medidas: 7 x 15 cm | 80gr.", img: `${CDN_URL}/static/social/TBOX_GRANDE.webp` },
				{ title: "Dubites 2 piezas", desc: "Medidas: 3 x 6.5cm | 12gr", img: `${CDN_URL}/static/social/DUBITES_CHICA.webp`},
				{ title: "Dubites 4 piezas", desc: "Medidas: 6.5 x 9.5cm | 40gr", img: `${CDN_URL}/static/social/DUBITES_MEDIANA.webp`},
				{ title: "Dubites 8 piezas", desc: "Medidas: 7 x 15 cm | 80gr", img: `${CDN_URL}/static/social/DUBITES_GRANDE.webp`},
			],
		},
		{
			name: 'Paletas',
			sizes_title: 'Modelos especiales',
			sizes_subtitle: 'Los colores se pueden personalizar acorde al evento.',
			products: [
				{ title: "Star Pop", desc: "Medidas: 3 x 6.5 cm | 12 gr.", img: `${CDN_URL}/static/social/STAR_POP.webp` },
				{ title: "Flower Pop", desc: "Medidas: 6.5 x 9.5 cm | 40gr.", img: `${CDN_URL}/static/social/FLOWER_POP.webp` },
				{ title: "Teddy Pop", desc: "Medidas: 7 x 15 cm | 80gr.", img: `${CDN_URL}/static/social/TEDDY_POP_AZUL.webp` },
			],
			flavors: [
				{ title: "Chocolate amargo", img: `${CDN_URL}/static/social/CH_AMARG.webp` },
				{ title: "Chocolate blanco", img: `${CDN_URL}/static/social/CH_BLANCO.webp` },
				{ title: "Chocolate de leche", img: `${CDN_URL}/static/social/CH_LECHE.webp` },
				{ title: 'Elige el color del decorado', img: `${CDN_URL}/static/social/COLOR.webp` }
			]
		},
		{
			name: 'Fresas',
			products: [
				{ title: "Media docena de fresas", desc: "Cubiertas de chocolate", img: `${CDN_URL}/static/social/MEDIADOCENA.webp` },
				{ title: "Docena de fresas", desc: "Cubiertas de chocolate", img: `${CDN_URL}/static/social/DOCENAFRESAS.webp` },
			],
			flavors: [
				{ title: "Chocolate amargo", img: `${CDN_URL}/static/social/CH_AMARG.webp` },
				{ title: "Chocolate blanco", img: `${CDN_URL}/static/social/CH_BLANCO.webp` },
				{ title: "Chocolate de leche", img: `${CDN_URL}/static/social/CH_LECHE.webp` },
				{ title: "Mixto", desc: 'Elige de 1 a 2 sabores de fresas' ,img: `${CDN_URL}/static/social/MIXTO.webp` }
			]
		},
	],
};


var CustomizedSocial = () => {
	var { setTitle } = useTitle();

	var [selectedCategory, setSelectedCategory] = useState<string>(DEFAULT_DATA.categories[0]?.name || '');

	// TODO: Replace DEFAULT_DATA with API response when the admin endpoint is ready
	// useEffect(() => {
	//   API.getCustomizedSocialData().then(res => {
	//     if (!res.error) setData(res.data);
	//   });
	// }, []);
	var [data] = useState<CustomizedSocialData>(DEFAULT_DATA);

	useEffect(() => {
		setTitle('Personalizados Sociales | COCOAN', false);
	}, []);

	var activeCategory = data.categories.find(c => c.name === selectedCategory) || data.categories[0];
	var products = activeCategory?.products || [];
	var flavors = activeCategory?.flavors || [];

	return (
		<main className='co customized-social-screen'>
			<header className='customized-social-hero'>
				<HeroVideo
					className="hero-bg"
					mobileClassName="hero-video-mobile"
					desktopClassName="hero-video-desktop"
					srcMobile={`${CDN_URL}/static/social/BANNER_SOCIALES_MOBILE.webm`}
					srcDesktop={`${CDN_URL}/static/social/BANNER_SOCIALES_DESKTOP.webm`}
				/>
				<div className='hero-overlay'>
					<h1><span className="font-graphik">Personalizados</span><br /><span className="font-homemade-apple">Sociales</span></h1>
				</div>
			</header>

			<section className="section-container">
				<article className="intro-section">
					<div className="text-content">
					<h2 className="font-graphik-light">Recuerdos especiales <br />con sabores <span className="font-graphik-bold">increíbles</span></h2>
					<p className="subtitle font-graphik-light">
							Personalizados únicos para cada momento, <br /> diseñados para impresionar y hechos para disfrutar.
						</p>
					</div>
					<figure className="image-content">
						<img src={`${CDN_URL}/static/social/SOCIALES.webp`} alt="Intro" />
					</figure>
				</article>
			</section>

			<section className="events-carousel-section">
				<h2 className="carousel-title">
					<span className="font-graphik-bold">Hacemos tu evento </span>
					<span className="font-homemade-apple">Especial</span>
				</h2>
				<div className="events-carousel-track">
					{[...Array(2)].map((_, setIdx) => (
						<div className="events-carousel-set" key={`carousel-set-${setIdx}`} aria-hidden={setIdx > 0}>
							{['Bodas', 'XV años', 'Bautizos', 'Graduaciones', 'Cumpleaños',
								'Baby Showers', 'Despedidas de soltera', 'Maternidad', 'Primera comunión',
								].map((event, i) => (
								<span className="event-item font-homemade-apple" key={`event-${setIdx}-${i}`}>
									{event}
									<span className="separator">•</span>
								</span>
							))}
						</div>
					))}
				</div>
			</section>

			<section className="how-to-choose-section" style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}>
				<div className="section-container">
					<div className="how-to-columns">
						<div className="cta-column">
							<h3 className="cta-title font-graphik-bold">
								Personalízalos sin<br />complicaciones.
							</h3>
							<p className="cta-subtitle font-graphik-regular">Nosotros lo hacemos por ti.</p>
							<div className="cta-buttons">
								<a
									className="cta-btn primary"
									href="https://wa.me/528129448353?text=%C2%A1Hola!%20Vengo%20de%20la%20p%C3%A1gina%2C%20me%20gustar%C3%ADa%20tener%20m%C3%A1s%20informaci%C3%B3n%20de%20personalizados."
									target="_blank"
									rel="noopener noreferrer"
								>
									Quiero cotizar
								</a>
								<a href='https://emperar.sfo3.digitaloceanspaces.com/cocoan/pages/assets/78.pdf' target='_blank' rel='noopener noreferrer' className="cta-btn secondary">
									Ver catálogo
								</a>
							</div>
						</div>
						<div className="steps-grid">
							<div className="step-card">
								<h3><span className="step-number">1</span> Contáctanos</h3>
								<p>Escríbenos por WhatsApp y/o dm's de instagram.</p>
							</div>
							<div className="step-card">
								<h3><span className="step-number">2</span> Cotízalo</h3>
								<p>Elige los productos que te interesen junto a las cantidades que necesites y la fecha para la que sea tu evento.</p>
							</div>
							<div className="step-card">
								<h3><span className="step-number">3</span> Realiza tu pago y comparte tu invitación.</h3>
								<p>Realiza tu pago y envíanos las referencias de tu evento, nosotros comenzaremos con tu diseño.</p>
							</div>
							<div className="step-card">
								<h3><span className="step-number">4</span> ¡Listo!, nosotros nos encargamos.</h3>
								<p>Espera pacientemente la fecha de entrega de tus chocolates para tu evento especial.</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="customized-social-banner2">
				<HeroVideo
					className="banner2-bg"
					mobileClassName="banner2-video-mobile"
					desktopClassName="banner2-video-desktop"
					srcMobile={`${CDN_URL}/static/social/BANNER2_SOCIALES_MOBILE.webm`}
					srcDesktop={`${CDN_URL}/static/social/BANNER2_SOCIALES_DESKTOP.webm`}
				/>
			</section>


			<section className="section-container products-section">
				<h2><span className="font-graphik">Personaliza a tu</span> <span className="font-homemade-apple">gusto</span></h2>

				<nav className="products-categories-nav">
					<ul className="categories-list">
						{data.categories.map((cat) => (
							<li
								key={cat.name}
								className={classNames("category-item", { active: selectedCategory === cat.name })}
								onClick={() => setSelectedCategory(cat.name)}
							>
								{cat.name}
							</li>
						))}
					</ul>
				</nav>

				{activeCategory?.sizes_title && (
					<div style={{ textAlign: 'center', marginBottom: 50 }}>
						<h3 className="font-graphik-bold" style={{ fontSize: 22, margin: '0 0 8px 0', color: '#111' }}>{activeCategory.sizes_title}</h3>
						{activeCategory.sizes_subtitle && (
							<p className="font-graphik-regular" style={{ fontSize: 16, color: '#666', margin: 0 }}>{activeCategory.sizes_subtitle}</p>
						)}
					</div>
				)}

				<div className="products-grid-layout">
					{products.map((item, idx) => (
						<Product
							key={`${selectedCategory}-${idx}`}
							product={{
								product_id: `${selectedCategory}-${idx}`,
								product_name: item.title,
								desc: item.desc || '',
								img: item.img
							}}
							link={false}
						/>
					))}
				</div>

				{flavors.length > 0 && (
					<>
						<div style={{ textAlign: 'center', marginBottom: 50 }}>
							<h3 className="font-graphik-bold" style={{ fontSize: 22, margin: '0 0 8px 0', color: '#111' }}>{activeCategory.flavors_title || 'Sabores a elegir'}</h3>
							{activeCategory.flavors_subtitle && (
								<p className="font-graphik-regular" style={{ fontSize: 16, color: '#666', margin: 0, padding: '0 50px' }}>{activeCategory.flavors_subtitle}</p>
							)}
						</div>

						<div className="products-grid-layout four-cols">
							{flavors.map((item, idx) => (
								<Product
									key={`flavor-${idx}`}
									product={{
										product_id: `flavor-${idx}`,
										product_name: item.title,
										desc: item.desc,
										img: item.img
									}}
									link={false}
								/>
							))}
						</div>
					</>
				)}

				{/* <div className="action-container">
					<Button as={Link} to="/shop" text='Ver más' />
				</div> */}
			</section>

			<section className="customized-selection-section">
				<img src={`${CDN_URL}/static/social/PERSONALIZADO_SELECCION.webp`} alt="Personalizado Selección" className="selection-bg" />
				<div className="selection-overlay">
					<h2 className="selection-title">
						Tu personalizado especial comienza <span className="font-homemade-apple">aquí.</span>
					</h2>
				</div>
			</section>

			<section className="customized-social-banner3">
				<HeroVideo
					className="banner3-bg"
					mobileClassName="banner3-video-mobile"
					desktopClassName="banner3-video-desktop"
					srcMobile={`${CDN_URL}/static/social/BANNER3_SOCIALES_MOBILE.webm`}
					srcDesktop={`${CDN_URL}/static/social/BANNER3_SOCIALES_DESKTOP.webm`}
				/>
			</section>

		</main>
	);
};

export default CustomizedSocial;
